package com.example.readingnotes.domain.usecase

import com.example.readingnotes.domain.repository.CommentRepository
import com.example.readingnotes.util.Result

class DeleteCommentUseCase(
    private val commentRepository: CommentRepository,
) {
    suspend operator fun invoke(
        id: String,
        totpCode: String? = null,
    ): Result<Unit> = commentRepository.deleteComment(id, totpCode)
}
